export function parseChatTag(tag: string): {
  fullId: string
  id: string
  threadId?: string
  name: string
} {
  // split off the human name (if any)
  const [fullId, namePart] = tag.split('::', 2)

  // fullId is like "chatid" or "chatid_threadid"
  const [id, threadIdRaw] = fullId.split('_', 2)

  return {
    fullId,
    id,
    threadId: threadIdRaw ?? undefined,
    name: namePart || fullId,
  }
}
